import { removeCheckPerm } from '../actions/permissionCheckerInternalActions';
import getStore from '../store/store';
import { mutator } from 'satcheljs';

mutator(removeCheckPerm, actionMessage => {
    const store = getStore();

    store.permissionCheckers.delete(actionMessage.composeId);
});
